import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import type { Order } from "../../../my-type";
import { cancelOrder, getOrder } from "../../../service/OrderService";
import Header from "../../../layouts/Header";
import OrderDisplay from "../../../components/OrderDisplay";
import { OrderActionType, UserRole } from "../../../my-enum";
import { Message, useToaster, Modal, Button } from "rsuite";
import PageBase from "../../../components/PageBase";

export default function RiderOrderDetail() {
  const { orderId } = useParams();
  const [step, setStep] = useState<number>(0);
  const [order, setOrder] = useState<Order | undefined>(undefined);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const toaster = useToaster();

  useEffect(() => {

    //window.scrollTo(0, 0);

    const toGetOrder = async (parmOrderId: string) => {
      let orderTemp = await getOrder(parmOrderId);
      if (orderTemp) {
        setOrder(orderTemp);
      }
    }

    // if (orderId && order === undefined) {
    //   toGetOrder(orderId);
    // }

    if (orderId) {
      toGetOrder(orderId);
    }
  }, [orderId]);

  // const innderStyle = () => {
  //   if (step === 0) {
  //     return { backgroundColor: 'white', height: '2000px' }
  //   } else {
  //     return {}
  //   }
  // };

  const doNavigate = () => {
    switch (step) {
      case 0:
        navigate("/rider/order")
        break;
      case 1:
        setStep(0);
        break;
      default:
        break;
    }
  };

  const messageErrorPush = (strMessage: string) => (
    <Message showIcon type="error" closable>
      {strMessage}
    </Message>
  );


  const onRiderClicked = async (order: Order, actionType: OrderActionType) => {
    //let accessToken = authUser!.jwtToken;
    if (actionType === OrderActionType.Cancel) {
      let cancelResult = await cancelOrder(order.orderID);
      if (cancelResult) {
        if (cancelResult.statusCode === 200) {
          setShowSuccessModal(true);
          return;
        } else {
          toaster.push(messageErrorPush(cancelResult.message), { placement: 'topCenter', duration: 2000 });
        }
      }
    }
  }

  const handleModalClose = () => {
    setShowSuccessModal(false);
    doNavigate();
  };


  const header = <Header HeaderTitle="訂單明細" isShowRefresh={false} OnReturn={doNavigate} OnRefresh={() => { }} />;


  return (
    <>
      <PageBase header={header} content={<>{order &&
        <OrderDisplay order={order} isShowDetail={true} userRole={UserRole.Rider} onOrderAction={onRiderClicked} />
      }</>} showSide={true} />

      <Modal open={showSuccessModal} onClose={handleModalClose} size="sm">
        <Modal.Header>
          <Modal.Title>取消成功</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>已成功取消預約訂單</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleModalClose} appearance="primary">
            確定
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );

}
